module.exports = __webpack_public_path__ + "static/media/screen4.ea098327.png";